import React from 'react';
import { Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import { DataGrid } from '../../Common';
import { StyledCellLinkWithFilter } from '../../Common/DataGrid/CellComponents';
import { getRangeFilterOperator } from '../../Common/DataGrid/FilterComponents';
import { text_commonCellProps } from '../../Common/DataGrid/utils';
import { Grey2 } from '../../../color_utils';
import Routes from '../../../routes';
import UserInfo from '../../../UserInfo';

const rangeFilterOperator = getRangeFilterOperator({});

const canEdit = UserInfo.isSystemAdministrator() ||
    UserInfo.isNativeTenantAdministrator() ||
    UserInfo.isNativeRegionalAdministrator() ||
    UserInfo.isNativeSuperTenantAdministrator();

const columns = [
    {
        field: 'systemManager',
        headerName: 'System manager',
        ...text_commonCellProps
    },
    {
        field: 'numberOfAssets',
        headerName: 'Number of assets',
        filterOperators: rangeFilterOperator,
        flex: 1,
        renderCell: ({ row: { systemManager, numberOfAssets } }) => (
            <StyledCellLinkWithFilter
                path={`/Inventory`}
                text={numberOfAssets}
                from={window.location.pathname}
                destinationTableUrl={Routes.Asset.AssetTable()}
                field='systemManager'
                value={systemManager}
                primaryLink
                currentPage='SystemManagerPage'
            />
        )
    }
]

const SystemManagerTable = ({
    refresh,
    exportFileRef,
    handleEdit,
    handleDelete
}) => {

    const rowActions = {
        type: 'actions',
        field: 'Quick Actions',
        width: 100,
        getActions: ({ row }) => canEdit ? [
            <GridActionsCellItem
                icon={
                    <Tooltip title="Edit System Manager">
                        <EditIcon sx={{ color: Grey2 }} />
                    </Tooltip>
                }
                onClick={() => handleEdit(row)}
            />,
            <GridActionsCellItem
                icon={
                    <Tooltip title="Delete System Manager">
                        <DeleteIcon sx={{ color: Grey2 }} />
                    </Tooltip>
                }
                onClick={() => handleDelete(row)}
            />
        ] : []
    }

    return (
        <>
            <DataGrid
                url={Routes.Account.SystemManagersTable()}
                exportButtonURL={Routes.Account.ExportSystemManagersTable()}
                printButtonURL={Routes.Account.ExportSystemManagersTable()}
                noResultText="Oops...It is empty here..."
                noResultText2="Add a new System manager or change your search criterias."
                exportFileName="SystemManagers"
                refresh={refresh}
                rowCount={5}
                columns={[...columns, rowActions]}
            />
        </>
    )
}

export default SystemManagerTable;